<template>
  <div class="lego-pagination" v-if="isPagination">
    <div
      class="lego-pagination__navi"
      :class="[{ 'lego-pagination__icon--disable': isDisableLeft }]"
      @click="onClick('prev')"
    >
      <lego-icon
        class="lego-pagination__left-icon"
        icon-type="df"
        icon="pagination_left_24"
        :size="24"
      />
      {{ $t('button.previous') }}
    </div>
    <div
      class="lego-pagination__navi"
      :class="[{ 'lego-pagination__icon--disable': isDisableRight }]"
      @click="onClick('next')"
    >
      {{ $t('button.next') }}
      <lego-icon
        class="lego-pagination__right-icon"
        icon-type="df"
        icon="pagination_right_24"
        :size="24"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const emit = defineEmits(['change-page']);

const props = defineProps({
  page: {
    type: Array,
    required: true
  }
});

const isPagination = computed(() => {
  return props.page.some((item) => item.rel == 'next' || item.rel == 'prev' || item.rel == 'self');
});
const isDisableLeft = computed(() => {
  return props.page.every((item) => item.rel !== 'self');
});
const isDisableRight = computed(() => {
  return props.page.every((item) => item.rel !== 'next');
});
const onClick = (type) => {
  const getPageSelect = props.page.filter((item) => item['rel'] == type);
  emit('change-page', getPageSelect.length ? getPageSelect[0].marker : '');
};
</script>
<style scoped lang="scss">
.lego-pagination {
  @include font($size: $lego-pagination__font-size);
  gap: 24px;
  .lego-pagination__navi {
    width: auto;
    margin: 0;
    color: #2e3138;
    .lego-icon {
      color: #2e3138;
    }
  }

  :deep .lego-pagination__left-icon,
  :deep .lego-pagination__right-icon {
    transform: rotate(0deg);
  }

  .lego-pagination__icon {
    &--disable {
      :deep .lego-icon {
        color: $lego-pagination__navi__icon-color--disabled;
      }
    }
    &--hide {
      display: none;
    }
  }

  .lego-pagination__navi {
    &:hover {
      background: none;
      color: #000000;
      .lego-icon {
        color: #000000;
      }
    }
  }
  .lego-pagination__number {
    &:active {
      color: $color--primary;
      font-weight: $lego__font-weight--bold;
    }
  }
}
</style>
